import Swiper, { Autoplay } from 'swiper';
import 'swiper/swiper-bundle.css';
Swiper.use([Autoplay]);
import { addPvNew, parseJson } from '../../../utils';
export default {
  name: 'consultCard',
  data() {
    return {
      swiper: null
    };
  },
  props: {
    poiList: {
      type: Array,
      default() {
        return [];
      }
    },
    consultObj: {
      type: Object,
      default() {
        return {};
      }
    },
    source: {
      type: String,
      default: ''
    }
  },
  computed: {
    consultsList() {
      const {
        basic_ques_list_json = ''
      } = this.consultObj || {
        basic_ques_list_json: ''
      };
      const quesList = parseJson(basic_ques_list_json);
      return quesList;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.swiper = new Swiper('.consult-swiper', {
        // 设置方向，水平方向(horizontal)或垂直方向(vertical)
        direction: 'vertical',
        allowTouchMove: false,
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        }
      });
    });
    this.showCardPoint();
  },
  methods: {
    // 拨打电话
    goTel() {
      var _this$poiList, _phone$split;
      const {
        bury: {
          levelOne = '',
          levelTwo = '',
          stdTag = ''
        }
      } = ((_this$poiList = this.poiList) === null || _this$poiList === void 0 ? void 0 : _this$poiList[0]) || {
        bury: {}
      };
      const {
        phone = ''
      } = this.consultObj || {
        phone: ''
      };
      const fristPhone = ((_phone$split = phone.split(',')) === null || _phone$split === void 0 ? void 0 : _phone$split[0]) || '';
      if (fristPhone) {
        addPvNew(['MCEDmm.MCEDpoiugc.NewMedia.microDetail.rfq.click'], {
          levelOne,
          levelTwo,
          stdTag,
          source: this.source || ''
        });
        window.location.href = `tel:${fristPhone}`;
      }
    },
    showCardPoint() {
      var _this$poiList2;
      const {
        bury: {
          levelOne = '',
          levelTwo = '',
          stdTag = ''
        }
      } = ((_this$poiList2 = this.poiList) === null || _this$poiList2 === void 0 ? void 0 : _this$poiList2[0]) || {
        bury: {}
      };
      /**
       * 广告展示埋点
       */
      this.$nextTick(() => {
        const consultCardRef = this.$refs.consultCardRef;
        consultCardRef && this.$io.observe(consultCardRef, () => {
          addPvNew(['MCEDmm.MCEDpoiugc.NewMedia.microDetail.rfq.show'], {
            levelOne,
            levelTwo,
            stdTag,
            source: this.source || ''
          });
        });
      });
    }
  }
};